import React from 'react'
import { Typography, TypographyProps } from '@mui/material'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'

const TextColorFontBody = (props: TypographyProps) => {
  const { children, sx, ...restProps } = props
  return (
    <Typography
      sx={{
        color: circlesOrbitColorPalette.text.main,
        fontSize: '14px',
        margin: '0',
        ...sx
      }}
      {...restProps}
    >
      {children}
    </Typography>
  )
}

export default TextColorFontBody
